import { Directive, ElementRef, Inject, Input, NgZone } from '@angular/core';
import { fromEvent, Observable, tap } from 'rxjs';
import { ComponentStore } from '@ngrx/component-store';
import { WINDOW } from '@ng-web-apis/common';
import { ScrollDispatcher } from '@angular/cdk/overlay';

@Directive({
  selector: '[i2lCssVarScrollRatio]',
  standalone: true,
})
export class CssVarScrollRatioDirective extends ComponentStore<
  Record<string, never>
> {
  @Input()
  windowMode = false;

  readonly getScrolling = this.effect((scrolling$: Observable<any>) => {
    return scrolling$.pipe(
      tap((event) => {
        const { nativeElement } = this.el;
        let viewportHeight;
        let contentHeight;
        let scrollTop;
        if (!this.windowMode) {
          viewportHeight = nativeElement.clientHeight;
          contentHeight = nativeElement.scrollHeight;
          scrollTop = nativeElement.scrollTop;
        } else {
          viewportHeight = this.window.innerHeight;
          contentHeight = this.window.document.body.scrollHeight;
          scrollTop = this.window.scrollY;
        }
        const scrollRatio = scrollTop / (contentHeight - viewportHeight);
        this.zone.runOutsideAngular(() => {
          nativeElement.style.setProperty(
            '--scroll-ratio',
            isNaN(scrollRatio) ? '0' : scrollRatio.toString()
          );
          nativeElement.style.setProperty('--scroll-top', `${scrollTop}px`);
        });
      })
    );
  });

  constructor(
    private el: ElementRef<HTMLElement>,
    private zone: NgZone,
    @Inject(WINDOW) private window: Window,
    private scrollDispatcher: ScrollDispatcher
  ) {
    super();
    const { nativeElement } = this.el;
    nativeElement.style.setProperty('--scroll-ratio', '0');
    nativeElement.style.setProperty('--scroll-top', '0px');
    if (this.windowMode) {
      this.getScrolling(
        this.scrollDispatcher.ancestorScrolled(this.el.nativeElement, 0)
      );
    } else {
      this.getScrolling(
        this.scrollDispatcher.ancestorScrolled(this.el.nativeElement, 0)
      );
    }
  }
}
